"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var FlagLB = function FlagLB(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "411.6",
    height: "270.36",
    viewBox: "0 0 411.6 270.36"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M216.6-65.5H-193v-49.44a7.06,7.06,0,0,1,7.06-7.06H209.54a7.06,7.06,0,0,1,7.06,7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M209.54,146.36H-185.94A7.07,7.07,0,0,1-193,139.3V89.86H216.6V139.3a7.06,7.06,0,0,1-7.06,7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "57.5",
    width: "409.6",
    height: "155.37",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M26.89,59.68l65.27-13a6.51,6.51,0,0,0-.28-12.82L22.35,23a3.56,3.56,0,0,1-3-4.1A3.72,3.72,0,0,1,23.6,16l48.21,6.35a4.21,4.21,0,0,0,3.62-7l-3.88-4.13a10,10,0,0,0-5.42-3L25.85.34,60.19,2.81a2.94,2.94,0,0,0,2.4-4.89L60.83-4a7.51,7.51,0,0,0-4-2.33L22.7-13.49l24.23-.7a2.52,2.52,0,0,0,1.8-4.2L47.64-19.6a6.74,6.74,0,0,0-3.18-2l-21.61-6.2h17A2.34,2.34,0,0,0,42-31.06l-.57-1.32a6.17,6.17,0,0,0-3.65-3.36L22.05-41.08l7.73,0a3.19,3.19,0,0,0,2.92-4.46A8,8,0,0,0,29-49.51L11.8-58.44-5.43-49.51A8,8,0,0,0-9.1-45.57a3.18,3.18,0,0,0,2.92,4.46l7.72,0-15.7,5.34a6.13,6.13,0,0,0-3.65,3.37L-18.38-31a2.33,2.33,0,0,0,2.14,3.26h17l-21.61,6.2a6.84,6.84,0,0,0-3.17,2l-1.09,1.21a2.52,2.52,0,0,0,1.8,4.2l24.23.7L-33.19-6.36a7.46,7.46,0,0,0-4,2.32l-1.76,2A2.93,2.93,0,0,0-36.6,2.81L-2.26.34l-40.27,7.8a10.08,10.08,0,0,0-5.43,3l-3.87,4.13a4.21,4.21,0,0,0,3.62,7L0,16a3.72,3.72,0,0,1,4.21,2.91,3.55,3.55,0,0,1-3,4.09L-68.28,33.82a6.45,6.45,0,0,0-4.19,2.5,6.51,6.51,0,0,0,3.91,10.31l65.27,13v8.15A16.8,16.8,0,0,1-8.2,79.69L-18.38,89.86H42L31.8,79.68a16.76,16.76,0,0,1-4.91-11.85Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "1",
    width: "409.6",
    height: "268.36",
    rx: "7",
    ry: "7",
    fill: "none"
  }));
};

var _default = FlagLB;
exports["default"] = _default;